require("pixi-particles");

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {AnimatedParticle, Emitter} from "pixi-particles";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";

export class CoinsFountain extends BaseView {

    private readonly _screenHeightRange:[number, number] = [720, 1760];
    private readonly _startSpeedRange:[number, number] = [650, 950];

    private _initMaxParticles:number = 200;
    private readonly _coinsConfigs:any[] = [
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.4,
                "end" : 0.5,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 700,
                "end" : 350,
                "minimumSpeedMultiplier" : 2
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1500
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 235,
                "max" : 310
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 20,
                "max" : 40
            },
            "lifetime" : {
                "min" : 2,
                "max" : 2
            },
            "blendMode" : "normal",
            "frequency" : 0.03,
            "emitterLifetime" : -1,
            "maxParticles" : this._initMaxParticles,
            "pos" : {
                "x" : GameConfig.instance.GAME_WIDTH / 2,
                "y" : GameConfig.instance.GAME_HEIGHT + 40,
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -5,
                "y" : 0,
                "w" : 10,
                "h" : 1
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.4,
                "end" : 0.5,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 700,
                "end" : 350,
                "minimumSpeedMultiplier" : 2
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1500
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 235,
                "max" : 310
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 20,
                "max" : 40
            },
            "lifetime" : {
                "min" : 2,
                "max" : 2
            },
            "blendMode" : "normal",
            "frequency" : 0.03,
            "emitterLifetime" : -1,
            "maxParticles" : this._initMaxParticles,
            "pos" : {
                "x" : GameConfig.instance.GAME_WIDTH / 2,
                "y" : GameConfig.instance.GAME_HEIGHT + 40,
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -5,
                "y" : 0,
                "w" : 10,
                "h" : 1
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.4,
                "end" : 0.5,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 700,
                "end" : 350,
                "minimumSpeedMultiplier" : 2
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1500
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 235,
                "max" : 310
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 20,
                "max" : 40
            },
            "lifetime" : {
                "min" : 2,
                "max" : 2
            },
            "blendMode" : "normal",
            "frequency" : 0.03,
            "emitterLifetime" : -1,
            "maxParticles" : this._initMaxParticles,
            "pos" : {
                "x" : GameConfig.instance.GAME_WIDTH / 2,
                "y" : GameConfig.instance.GAME_HEIGHT + 40,
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -5,
                "y" : 0,
                "w" : 10,
                "h" : 1
            }
        }
    ];

    private _coinsEmitters:Emitter[];
    private _layer:ScalableLayer;
    private _isPlaying:boolean = false;
    private _currentOrientation:Orientation
    private _currentLevel:number = -1;

    public startFountain(playLevel:number, isBigWin:boolean = true):void {
        this._currentLevel = playLevel;
        this._isPlaying = true;
        if(this._isResizeDirty) {
            this.onResize(this._resizeData);
        }
        this._coinsEmitters.forEach((emitter:Emitter, level:number) => {
            if(level < playLevel || !isBigWin) {
                emitter.maxParticles /= 2;
            }
            if(level <= playLevel) {
                emitter.emit = true;
            }
        });
    }

    public stopFountain():void {
        this._currentLevel = -1;
        this._isPlaying = false;
        this._coinsEmitters.forEach((emitter:Emitter) => {
            emitter.emit = false;

            emitter.maxParticles = this._initMaxParticles;
        });
    }

    protected initAnimations():void {
        this._layer = StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.FOUNTAIN.name);
        this._coinsEmitters = [];
    }

    protected onResize(resizeData:IResizeData):void {
        if(this._currentOrientation === this._resizeData.orientation) {
            return;
        }

        if(!this._isPlaying) {
            this._isResizeDirty = true;
            return;
        }

        this._isResizeDirty = false;
        this._currentOrientation = resizeData.orientation;
        while(this._coinsEmitters.length > 0) {
            const emitter = this._coinsEmitters.pop()!;
            // emitter.cleanup();
            ParticlesManager.removeEmitter(emitter);
        }

        let screenHeight:number = Math.ceil(resizeData.height / this._layer.scale.y);
        let screenHeightInRange = Math.max(this._screenHeightRange[0], Math.min(screenHeight, this._screenHeightRange[1]));
        const startSpeed:number = Math.ceil((screenHeightInRange - this._screenHeightRange[0]) * (this._startSpeedRange[1] - this._startSpeedRange[0]) / (this._screenHeightRange[1] - this._screenHeightRange[0]) + this._startSpeedRange[0]);
        const y:number = Math.floor(-this._layer.y / this._layer.scale.y) + screenHeight + 40;
        this._coinsConfigs.forEach((config:{ speed:{ start:number, end:number }, pos:{ y:number } }, level:number) => {
            const levelSpeed:number = startSpeed * (1 + 0.05 * level);
            config.speed.start = levelSpeed;
            config.speed.end = levelSpeed;
            config.pos.y = y;
        });
        this.addEmitters();
        this.startFountain(this._currentLevel);
    }

    private addEmitters():void {
        this._coinsConfigs.forEach((config:any, level:number) => {
            const emitter:Emitter = new Emitter(this._layer, [{
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures(`bigWinCoin${level}`)
            }], config);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            this._coinsEmitters.push(emitter);
        });
    }
}